import React from 'react';
import './GetResetPage.css';

const gumroadLink = 'https://graphicawork.gumroad.com/l/lxbvgt';

function GetResetPage() {
  return (
    <main className="getreset-page">
      <div className="getreset-shell">
        <section className="hero-card">
          <div>
            <div className="eyebrow">30-day execution system</div>
            <h1>30-Day Canada Reset System</h1>
            <p className="lead">
              A focused plan for international students in Canada who want structure, momentum, and a real path to their first job.
            </p>
            <div className="hero-actions">
              <a className="primary-btn" href={gumroadLink} target="_blank" rel="noreferrer">
                Get the system on Gumroad
              </a>
            </div>
          </div>

          <div className="hero-stack">
            <div className="signal">
              <strong>Built for clarity</strong>
              <p>No random applications. No guesswork. Just a daily system you can follow.</p>
            </div>
            <div className="signal">
              <strong>Made for action</strong>
              <p>Resume help, message scripts, interview prep, and the daily plan are all included.</p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default GetResetPage;
